// https://www.concretepage.com/angular-2/angular-candeactivate-guard-example

import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

export interface CanPageDeactive {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
    providedIn: 'root',
})
export class CanPageDeactiveGuardService {
    canDeactivate(component: CanPageDeactive) {
        return component && component.canDeactivate ? component.canDeactivate() : true;
    }
}
